export * from './IVirtualElement';
export * from './elementContains';
export * from './elementContainsAttribute';
export * from './findElementRecursive';
export * from './getChildren';
export * from './getParent';
export * from './getVirtualParent';
export * from './isVirtualElement';
export * from './portalContainsElement';
export * from './setPortalAttribute';
export * from './setVirtualParent';

import './version';
